// Dogfight — ported from GolfGamesScorecard's dogfight-scorecard.tsx. Net vs par
// per hole scores points (dogfightPointsFor): eagle-or-better 4 · birdie 3 ·
// par 2 · bogey 1 · worse 0 (net ≤ 0 → 0). Net = max(1, gross − strokes).
// Result is points over/under a per-player quota, with optional $/point.
import { strokesOnHole } from './ggHandicap.js'

export function dogfightPointsFor(net, par) {
  if (net <= 0) return 0
  const diff = net - par
  if (diff <= -2) return 4
  if (diff === -1) return 3
  if (diff === 0) return 2
  if (diff === 1) return 1
  return 0
}

export function calcDogfight(players, pars, strokeIndex, { handicapsOn = true, dollarsPerPoint = 0, quota = 36 } = {}) {
  return (players || [])
    .map((p) => {
      const pointsByHole = p.scores.map((gross, h) => {
        if (gross == null || gross <= 0) return 0
        const strokes = handicapsOn ? strokesOnHole(p.handicap, h, strokeIndex) : 0
        const net = Math.max(1, gross - strokes)
        return dogfightPointsFor(net, pars[h] ?? 4)
      })
      const total = pointsByHole.reduce((s, v) => s + v, 0)
      const q = Number.isFinite(Number(p.quota)) ? Number(p.quota) : quota
      const vsQuota = total - q
      return { ...p, pointsByHole, total, quota: q, vsQuota, dollars: vsQuota * (Number(dollarsPerPoint) || 0) }
    })
    .sort((a, b) => b.vsQuota - a.vsQuota)
}
